import { useState, useEffect } from 'react';

const MAX_VISIBLE_RECIPIENTS_WIDE = 5;
const MAX_VISIBLE_RECIPIENTS_NARROW = 3;
const NARROW_WIDTH_BREAKPOINT = 600;

export const useDisplayLimit = (colRef: React.RefObject<HTMLDivElement>) => {
    const [displayLimit, setDisplayLimit] = useState(MAX_VISIBLE_RECIPIENTS_WIDE);

    useEffect(() => {
        const updateDisplayLimit = () => {
            if (colRef.current) {
                const width = colRef.current.offsetWidth;
                setDisplayLimit(
                    width < NARROW_WIDTH_BREAKPOINT ? MAX_VISIBLE_RECIPIENTS_NARROW : MAX_VISIBLE_RECIPIENTS_WIDE
                );
            }
        };
        // Initial calculation on mount
        updateDisplayLimit();

        // Recalculate on window resize
        window.addEventListener('resize', updateDisplayLimit);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', updateDisplayLimit);
        };
    }, [colRef]);

    return { displayLimit };
};
